const GalleryBorderSkeleton = () => {
  return <div className="relative w-full h-full"></div>
}

export default GalleryBorderSkeleton